'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = convertToWixAvailability;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _leftPad = require('left-pad');

var _leftPad2 = _interopRequireDefault(_leftPad);

var _days = require('./days');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function convertToWixAvailability(a, locale, timezone) {
    if (!a) return a;

    var ret = {};

    if (a.weekly) {
        ret.periods = convertWeekly(a.weekly);
    } else {
        ret.periods = convertWeekly([{ minuteOfWeek: 0, durationMins: 10080 }]);
    }

    if (a.exceptions) {
        ret.specialHourPeriods = convertExceptions(a.exceptions, locale, timezone);
    }

    return ret;
}

function convertExceptions(e, locale, timezone) {
    return e.map(function (p) {
        var wixException = {
            isClosed: !p.available,
            comment: _lodash2.default.get(p, 'comment[\'' + locale + '\']')
        };

        if (p.reason) {
            wixException.reason = p.reason;
        }

        if (p.start) {
            wixException.startDate = exceptionDateToIsoDate(p.start, timezone);
        }

        if (p.end) {
            wixException.endDate = exceptionDateToIsoDate(p.end, timezone);
        }

        return wixException;
    });
}

function exceptionDateToIsoDate(_ref, timezone) {
    var year = _ref.year,
        month = _ref.month,
        day = _ref.day,
        hour = _ref.hour,
        minute = _ref.minute;

    var d = (0, _momentTimezone2.default)().tz(timezone).year(year).month(month - 1).date(day).hour(hour).minute(minute).seconds(0).milliseconds(0);
    return d.toISOString();
}

function convertWeekly(w) {
    return w.map(function (p) {
        var day1 = minuteOfWeekToDowTime(p.minuteOfWeek);
        var day2 = minuteOfWeekToDowTime(p.minuteOfWeek + p.durationMins);

        return {
            openDay: day1.day,
            openTime: day1.time,
            closeDay: day2.day,
            closeTime: day2.time
        };
    });
}

function minuteOfWeekToDowTime(mow) {
    var dowOffset = Math.floor(mow / 1440);
    var dow = (0, _days.getDow)(dowOffset);
    var remainder = mow % 1440;
    var hours = Math.floor(remainder / 60);
    var mins = remainder % 60;
    return {
        day: dow,
        time: (0, _leftPad2.default)(hours, 2, 0) + ':' + (0, _leftPad2.default)(mins, 2, 0)
    };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/wix-availability/convertToWixAvailability.js
// module id = 1017
// module chunks = 0